export default {
  API_PREFIX: '/client',
};
